// extracted by mini-css-extract-plugin
export default {"title":"lnG7AxHNNoNQe2m9mcCA"};